import { render } from "./UserActiveIcon.vue?vue&type=template&id=5ee31200"
import script from "./UserActiveIcon.vue?vue&type=script&lang=js"
export * from "./UserActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__